export default __webpack_public_path__ + "img/c612e449e31226b66d53cd84edba13c4.png";